export default __webpack_public_path__ + "static/media/nodeLogo.c2e22c63.png";